<dx-popup
    width="50%"
    height="55%"
    title="Manage QA Users"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="manage-beta-testers-container">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        [stateConfig]="{ storageKey: 'MANAGE_BETA_TESTERS_GRID' }"
                        [gridFeatures]="{ allowPaging: false }"
                        [dataSource]="qaUsers"
                    >
                        <dx-data-grid
                            width="100%"
                            height="100%"
                            [dataSource]="qaUsers"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                            (onContentReady)="onGridContentReady($event)"
                        >
                            <dxo-editing
                                mode="cell"
                                [allowUpdating]="true"
                                [allowAdding]="true"
                                [allowDeleting]="false"
                                [useIcons]="true"
                            ></dxo-editing>
                            <dxi-column
                                dataField="moduleCode"
                                dataType="string"
                                caption="Module Name"
                                width="30%"
                                [allowEditing]="false"
                            >
                                <dxo-lookup [dataSource]="qaModules" displayExpr="title" valueExpr="code"></dxo-lookup>
                            </dxi-column>
                            <dxi-column
                                dataField="usersList"
                                dataType="string"
                                caption="QA Users"
                                width="70%"
                                editCellTemplate="tagBoxEditor"
                                [allowSorting]="false"
                                [showEditorAlways]="true"
                            ></dxi-column>
                            <div *dxTemplate="let row of 'tagBoxEditor'">
                                <dx-tag-box
                                    placeholder="Enter Tester's User Id(s)"
                                    noDataText="Enter Tester's User Id(s)"
                                    applyValueMode="instantly"
                                    [value]="row.value"
                                    [showClearButton]="true"
                                    [acceptCustomValue]="true"
                                    [showSelectionControls]="false"
                                    [showMultiTagOnly]="false"
                                    (onValueChanged)="onRowValueChanged($event, row)"
                                    (onSelectionChanged)="row.component.updateDimensions()"
                                ></dx-tag-box>
                            </div>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="footer-toolbar">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [delay]="0"
></dx-load-panel>
